import { Callout } from '../../../../../components';
import Layout from '../Layout';
import { SetupIPACategoryLevelsCategoryLevels } from './components';
import { SetupIPACategoryLevelsCategoryLevelsButtons } from './components/SetupIPACategoryLevelsCategoryLevelsButtons';
import { SetupIPACategoryLevelsCategoryMargin } from './components/SetupIPACategoryLevelsCategoryMargin';
import { SetupIPACategoryLevelsOptimizationCategory } from './components/SetupIPACategoryLevelsOptimizationCategory';
import { useCategoryLevels } from './hooks';
import styles from './SetupIPACategoryLevels.module.scss';

export const SetupIPACategoryLevels = () => {
  const { form, queriesCategoryLevels, fields } = useCategoryLevels();
  const { handlers, queriesData } = queriesCategoryLevels;

  return (
    <Layout.Root onSubmit={form.handleSubmit(handlers.update)}>
      <SetupIPACategoryLevelsCategoryLevels form={form} segments={fields} />
      <SetupIPACategoryLevelsCategoryMargin form={form} segments={fields} queryObjectiveMargin={queriesData?.queryObjetiveMargin} />
      {/* TODO: vamos liberar apenas quando liberar o papel de categoria  */}
      {/* <SetupIPACategoryLevelsCategoryRoleCalculation form={form} segments={fields} queryCategoryRole={queriesData?.queryCategoryRole} /> */}
      <SetupIPACategoryLevelsOptimizationCategory form={form} segments={fields} queryOptimizationCategory={queriesData?.queryOptimizationCategory} />
      <div className={styles.warning}>
        <Callout variant="warning" size="sm">
          As modificações realizadas até as 22h serão aplicadas na próxima integração de dados. Após esse horário, elas refletem na integração do dia seguinte.
        </Callout>
      </div>

      <SetupIPACategoryLevelsCategoryLevelsButtons />
    </Layout.Root>
  );
};
